import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  isShopifyTarget = signal<boolean>(false);

  isShopify = signal<boolean>(false);
  learningMode = signal<boolean>(false);
  autoActivate = signal<boolean>(false);
  behamicsDeactivated = signal<boolean>(false);

  targetUrl = signal<string>('');

  /** The selected target's `firstLiveWithNudge` date (ISO string) from `/targets`. */
  firstLiveWithNudge = signal<string | null>(null);

  /** The selected target's `ab_testing_tool` flag: the new nudge view instead of the old one. */
  abTestingView = signal<boolean>(false);

  /**
   * `abTestingView` has been set for this session's target. Until then it is
   * only the default, and the localStorage copy may be empty (logout clears
   * it) or another target's — so `/master-preview` waits for this rather than
   * load one nudge view and swap to the other a moment later.
   */
  abTestingViewKnown = signal<boolean>(false);
}
